import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import useId from '../utils/useId';
import {
  RadioRoot,
  RadioButtonContainer,
  RadioButton,
  RadioButtonInput,
  RadioButtonPoint,
  RadioContainer,
  StyledLabel,
} from './Radio.styles';
import { RadioProps } from './Radio.types';
import HelperText from '../HelperText';

const Radio: React.FC<RadioProps> = ({
  disabled,
  label,
  id: idOverride,
  name,
  value,
  checked,
  inputProps = {},
  inputRef = null,
  labelProps = {},
  error = false,
  helperText,
  helperTextProps = {},
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const id = useId(idOverride);
  const labelId = label && `${id}-label`;
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;

  return (
    <RadioRoot disabled={disabled} {...props}>
      <RadioButtonContainer>
        <RadioContainer>
          <RadioButtonInput
            {...inputProps}
            name={name}
            aria-describedby={labelId}
            disabled={disabled}
            value={value}
            type="radio"
            ref={inputRef}
          />
          <RadioButton disabled={disabled} checked={checked} error={error}>
            <RadioButtonPoint checked={checked} disabled={disabled} error={error} />
          </RadioButton>
        </RadioContainer>
        {label && (
          <StyledLabel
            {...labelProps}
            variant={theme.isNewVersion ? 'paragraphMedium' : 'labelMedium'}
            color="currentColor"
            id={labelId}
          >
            {label}
          </StyledLabel>
        )}
      </RadioButtonContainer>
      <HelperText disabled={disabled} error={error} show={!!helperText} id={helperTextId}>
        {helperText}
      </HelperText>
    </RadioRoot>
  );
};

export default Radio;
